/**
 * Main(-JS-File)
 */

import {getRootVar} from '../shared/utils/index';

import config from '../default/config/config';
import l10n from '../default/config/l10n';
import componentShared from '../shared';
import componentsCustom from './components';
// import initial from './initial';
// import layout from './layout';
// import vendors from './vendors';

import TranslationManager from '../shared/service/translation-manager';

// --------
// Let's go
// --------

document.addEventListener('DOMContentLoaded', function () {
	componentsCustom();
});